module.exports = __webpack_public_path__ + "static/media/logo-barbosa.81cf48fc.png";